import { legacyPageRedirect } from "@/lib/legacy-page-redirects";

// Old WordPress blog paths: /blog/<slug>/, /blog/page/<n>/, /blog/ask-an-expert/
// and /hair-loss-blog/page/<n>/. Blog posts still link to them.
//
// The targets match the redirects that the WordPress staging copy
// (staging-thriverestorehair.kinsta.cloud) served on 30 Sep 2026:
//   /blog/page/2/                -> /hair-loss-blog/
//   /blog/ask-an-expert/         -> /contact-us/
//   /blog/<post-slug>/           -> /<post-slug>/
const BLOG_INDEX = "/hair-loss-blog/";

const LEGACY_BLOG_SLUGS: Record<string, string> = {
  "ask-an-expert": "/contact-us/",
};

/**
 * The 301 target for a path under /blog/ or /hair-loss-blog/.
 *
 * `rest` is the part of the path after the blog prefix, for example
 * "page/2" or "how-soon-can-i-return-to-work-after-a-hair-transplant".
 * A retired page slug goes straight to its final target, so the visitor
 * gets one redirect and not a chain.
 */
export function legacyBlogTarget(rest: string): string {
  const parts = rest.split("/").filter(Boolean);
  // Category and tag archives redirect to the blog index (ARCHIVE in
  // legacy-path-redirects.ts), so their old /blog/ forms go there directly.
  if (parts.length === 0 || parts[0] === "page") return BLOG_INDEX;
  if (parts.length !== 1) return BLOG_INDEX;
  const slug = parts[0];
  return LEGACY_BLOG_SLUGS[slug] ?? legacyPageRedirect(slug) ?? `/${slug}/`;
}
